import React from 'react'
import {useQuery} from '@tanstack/react-query'
import {QueryCacheKeys} from '../../QueryKey'
import {getEventDetail} from '../../../apis/event/getEventDetail'

const useQueryEventDetail = (id: string) => {
    const {data, refetch} = useQuery({
        queryKey: QueryCacheKeys.event.getEventDetail(id),
        queryFn: async () => {
            const {data} = await getEventDetail(id)
            return data
        },
        refetchOnWindowFocus: false,
    })

    return {data, refetch}
}

export default useQueryEventDetail
